import React from 'react';
import _toArray from "lodash-es/toArray";
import OutsideClickHandler from 'react-outside-click-handler';
import { CreateGroupHoc, ArrowBackHoc, EditCameraHoc, TakephotoHoc, ViewphotoHoc, RemoveHoc, InfoHoc, ImgUserPlaceholder
} from '../../../assets/images';
import "./newGroup.scss";
import "../../Common/popup.scss";
import { REACT_APP_GROUP_NAME_CHAR, REMOVE_PHOTO, VIEW_PHOTO } from '../../../processENV';
import { removeMoreNumberChar } from "../../../Helpers/Chat/ContentEditableEle"

const NewGroupProfile = (props = {}) => {
    const groupNameInput = React.useRef(null);
    const { 
        handleBackToRecentChat = () => {},
        handleMoveToPartcipantList = () => {},
        typingMessage:typingMessageProps = '',
        groupProfileImage:groupProfileImageprops = ImgUserPlaceholder,
    } = props;
    const [getNewGroupProfile, setNewGroupProfile] = React.useState({
        loading: '',
        loaderIcon: false,
        cameraPopup: false,
        showProfileImg: false,
        showProfileCamera: false,
        onCameraPermissionDenied: false,
        onCameraError: false,
        showImgDropDown: false,
        showEmoji: false,
        typingMessage: typingMessageProps,
        groupProfileImage: groupProfileImageprops,
        errorMessage: false,
        groupNameChars: REACT_APP_GROUP_NAME_CHAR - typingMessageProps.length,
        showProfilePhotoRemove:false, 
    });
    const { showImgDropDown, typingMessage, groupProfileImage, errorMessage, groupNameChars } = getNewGroupProfile;
    /**
     * handleCropImage() to load the loader for croppie.
     */
    /**
    // const handleCropImage = () => {
    //     setNewGroupProfile({...getNewGroupProfile, loaderIcon: true }, () => cropImage());
    // }
    */

    /**
     * cropImage() to crop the selected image.
     */
    /**
    // const cropImage = () => {
    //     cropme.result({
    //         type: "base64",
    //         size: "original"
    //     }).then(base64 => {
    //         const imageFile = dataURLtoFile(base64, filename);
    //         setNewGroupProfile({...getNewGroupProfile,
    //             loaderIcon: true
    //         }, () => aftercropedImage(imageFile))
    //     })
    // }
    */

    /**
     * handleSaveImage() to save the selected image.
     */
    /**
    // const aftercropedImage = file => {
    //     const urlCreator = window.URL || window.webkitURL;
    //     const imageUrl = urlCreator.createObjectURL(file);
    //     setNewGroupProfile({...getNewGroupProfile,
    //         groupProfileImage: imageUrl,
    //         errorMessage: false
    //     }, () => {
    //         return handleProfileCameraPopupClose()
    //     })
    // };
    */

    /**
     * updateProfileImageNewImg() to get image file from child component.
     */
    /**
    // const updateProfileImageNewImg = (fileNewProfile = {}) => {
    //     if (cropme) {
    //         cropme.destroy();
    //     }
    //     if (fileNewProfile) {
    //         setNewGroupProfile({...getNewGroupProfile,
    //             filename: fileNewProfile.name,
    //             camImage: fileNewProfile,
    //             cameraPopup: true
    //         }, () => {
    //             const elementNewProfile = document.getElementById("CameraContainer")
    //             cropme = new Cropme(elementNewProfile, WebChatCropOption);
    //             var readerNewProfile = new FileReader();
    //             readerNewProfile.onload = function (e) {
    //                 cropme.bind({
    //                     url: e.target.result
    //                 }).then(() => {
    //                     Object.assign(document.querySelector('.cr-viewport').style, {
    //                         width
    //                             : '200px', height: '200px'
    //                     })
    //                     cropme.setZoom(0)
    //                 })
    //             };
    //             readerNewProfile.readAsDataURL(fileNewProfile);
    //         })
    //     }
    // }
    */

    /**
     * handleViewProfile() method to maintain state for view profile popup.
     */
    /**
    // const handleViewProfile = () => {
    //     setNewGroupProfile({...getNewGroupProfile, viewProfileStatus: true });
    // }
    */

    /**
     * handleVCardClose() method to maintain state for view profile popup close window state.
     */
    /**
    // const handleVCardClose = () => {
    //     setNewGroupProfile({...getNewGroupProfile,
    //         viewProfileStatus: false,
    //         viewEmojiUsername: false,
    //         viewEmojiStatus: false,
    //         viewEdit: true,
    //         viewEditStatus: true,
    //         viewTick: true,
    //         viewTickStatus: true,
    //         charCount: false,
    //         charCountStatus: false,
    //         showImgDropDown: false,
    //         showProfilePhotoRemove: false
    //     });
    // }
    */

    /**
     * removeProfileImage() method to maintain state to profile picture.
     */
    /**
    // const removeProfileImage = async (e) => {
    //     setNewGroupProfile({...getNewGroupProfile,
    //         showProfilePhotoRemove: false,
    //         groupProfileImage: ''
    //     });
    // }
    */

    /**
     * setWebcamImage() method to maintain state to set a image taken from webcamera.
     */
    /**
    // const setWebcamImages = (webcamImages = {}) => {
    //     if (webcamImages.size > 0) {
    //         let file = new FileReader();
    //         file.readAsDataURL(webcamImages);
    //         file.onload = () => {
    //             let fileImages = file.result;
    //             setNewGroupProfile({...getNewGroupProfile,
    //                 photoTaken: true, camImageDisplay: fileImages, camImage: webcamImages
    //             }, () => updateProfileImageNewImg(webcamImages))
    //         }
    //     } else {
    //         setNewGroupProfile({...getNewGroupProfile, showProfileCamera: true })
    //     }
    // }
    */

    /**
     * onCameraCheckGrupPic() method to find whether camera device is there.
     */
    /**
    // const onCameraCheckGrupPic = (errorsNewGrp = {}) => {
    //     if (errorsNewGrp.name === "NotAllowedError") {
    //         setNewGroupProfile({...getNewGroupProfile, onCameraPermissionDenied: true });
    //     } else if (errorsNewGrp.name === "NotFoundError") {
    //         setNewGroupProfile({...getNewGroupProfile, onCameraError: true })
    //     }
    // }
    */

    /**
     * handleNewProfileImgDropDown() method to maintain state to show dropdown in profile page.
     */
    const handleNewProfileImgDropDown = (e) => {
        e.stopPropagation();
        setNewGroupProfile({...getNewGroupProfile, showImgDropDown: !showImgDropDown })
    }

    /**
     * handleProfileImgClose() method to maintain state to close profile image.
     */
    /**
    // const handleProfileImgClose = (e) => {
    //     setNewGroupProfile({...getNewGroupProfile, showProfileImg: false });
    // }
    */

    /**
     * handleProfileCameraShow() method to open camera popup.
     */
    const handleProfileCameraShow = (e) => {
        setNewGroupProfile({...getNewGroupProfile, showProfileCamera: true, showImgDropDown: false, photoTaken: false, cameraLoader: true });
    }

    /**
     * handleProfilePhotoRemoveShow() method to open profile photo remove prompt.
     */
    const handleProfilePhotoRemoveShow = (e) => {
        setNewGroupProfile({...getNewGroupProfile,
            showProfilePhotoRemove: true,
            showImgDropDown: false,
            groupProfileImage: ''
        });
    }

    /**
     * handleProfileRemovephotoClose() method to close profile photo remove prompt.
     */
    /**
    // const handleProfileRemovephotoClose = (e) => {
    //     setNewGroupProfile({...getNewGroupProfile, showProfilePhotoRemove: false });
    // }
    */

    /**
     * handleProfileCameraPopupClose() method to close profile camera popup.
     */
    /**
    // const handleProfileCameraPopupClose = () => {
    //     setNewGroupProfile({...getNewGroupProfile,
    //         showProfileCamera: false,
    //         photoTaken: true,
    //         onCameraError: false,
    //         onCameraPermissionDenied: false,
    //         loaderIcon: false,
    //         cameraPopup: false,
    //         showImgDropDown: false
    //     });
    // }
    */

    const checkNotFound = (event) => {
        event.target.src = GroupProfile
    }

    /**
    // const afterImageLoad = (event) => event.target.style.backgroundImage = '';
    */
    const findNegativeValue = (message = "") => {
        const groupNameLength = REACT_APP_GROUP_NAME_CHAR - _toArray(message).length;
        if (groupNameLength >= 0) {
            return REACT_APP_GROUP_NAME_CHAR - _toArray(message).length;
        }
        return 0;
    };

    const handleMessage = (event = {}) => {
        const { value = "" } = event.target;
        const message = removeMoreNumberChar(REACT_APP_GROUP_NAME_CHAR, value);        
        setNewGroupProfile({...getNewGroupProfile,
            typingMessage: message,
            groupNameChars: findNegativeValue(message),
            errorMessage: false
        });
    }

    /**
    // const handleEmojiText = (emojiObject = "") => {
    //     const message = removeMoreNumberChar(REACT_APP_GROUP_NAME_CHAR, typingMessage + emojiObject);
    //     setNewGroupProfile({...getNewGroupProfile,
    //         typingMessage: message,
    //         groupNameChars: findNegativeValue(message),
    //         errorMessage: false
    //     });
    // }
    */


    /**
     * handleProfileImageShow() method to maintain state to show profile image in big screen.
     */
    const handleProfileImageShow = (e) => {
        setNewGroupProfile({...getNewGroupProfile, showProfileImg: true, showImgDropDown: false });
    }

    const nextScreen = () => {
        if (typingMessage.trim().length === 0) {
            setNewGroupProfile({...getNewGroupProfile,
                errorMessage: true
            })
            return
        }
        handleMoveToPartcipantList({
            typingMessage, groupProfileImage, profileImage: true
        })
    };

    /**
    // const closeDropDown = () => {
    //     console.log("closeDropDown");
    // };
    */

    React.useEffect(() => {
        groupNameInput && groupNameInput.current.focus();
    },[]);
    let editCamera = false

    return (
        <OutsideClickHandler
            onOutsideClick={() => {
                setNewGroupProfile({...getNewGroupProfile, showImgDropDown: false });
            }}>
            <React.Fragment>
                <div className="contactlist ">
                    <div className="recent-chatlist-header">
                        <div className="profile-img-name">
                            <i className="newchat-icon" onClick={handleBackToRecentChat} title="Back">
                                <ArrowBackHoc viewBox="0 0 24 24"/>
                            </i>
                            <span>{"New Group"}</span>
                            <div title="Select group members" onClick={nextScreen}>Next
                                    <i className="nextGroup-icon"  >
                                    <CreateGroupHoc  viewBox="0 0 4.266 7.11"/>
                                </i>
                            </div>
                        </div>
                    </div>
                    <div className="newgroup-details-container">
                        <div className="group-details-inner">
                            <div className="group-image-container">
                                <div className="group-image-inner">
                                    {groupProfileImage &&
                                        <img src={groupProfileImage} onClick={(e) => handleProfileImageShow(e)} onError={checkNotFound} alt="Group Profile" />
                                    }
                                    {!groupProfileImage &&
                                        <span onClick={(e) => handleNewProfileImgDropDown(e)} className="createNewGroup">
                                            <img src={groupProfileImage} onError={checkNotFound} alt="Group Profile" />
                                        </span>
                                    }
                                    {editCamera && <>
                                    <i className="camera-edit" onClick={(e) => handleNewProfileImgDropDown(e)}>
                                        <EditCameraHoc />
                                    </i>
                                    {showImgDropDown &&
                                        <ul className="menu-dropdown">
                                            {groupProfileImage &&
                                                <li className="ViewPhoto" title={VIEW_PHOTO}
                                                    onClick={(e) => handleProfileImageShow(e)}>
                                                    <i className="profileedit-options"><ViewphotoHoc />
                                                    </i><span>{VIEW_PHOTO}</span></li>
                                            }
                                            <li className="TakePhoto" title="Take Photo" onClick={(e) => handleProfileCameraShow(e)}>
                                                <i><TakephotoHoc /></i><span>Take Photo</span></li>
                                            {groupProfileImage &&
                                                <li className="RemovePhoto" title={REMOVE_PHOTO} onClick={(e) => handleProfilePhotoRemoveShow(e)}>
                                                    <i className="profileedit-options"><RemoveHoc /></i>
                                                    <span>{REMOVE_PHOTO}</span></li>
                                            }
                                            {/* <li className="UploadPhoto" title="Upload Photo"><i><Upload /></i>
                                                <span className="uploadphoto"><span>{UPLOAD_PHOTO}</span>
                                                    <WebChatCroppie
                                                        closeDropDown={closeDropDown}
                                                        loader={loaderIcon}
                                                        cameraPopup={cameraPopup}
                                                        closePopUp={handleProfileCameraPopupClose}
                                                        type={PROFILE}
                                                        updateProfileImage={updateProfileImageNewImg}
                                                        cropImage={cropImage} />
                                                </span>
                                            </li> */}
                                        </ul>
                                    }
                                    </>
                                    }
                                </div>
                            </div>
                            <div className="form-control">
                                <input
                                    type="text"
                                    ref={groupNameInput}
                                    value={typingMessage}
                                    onChange={handleMessage}
                                    placeholder="Type group name here..."
                                    maxLength={findNegativeValue(typingMessage) > 0 ? 1000 : 0}
                                />
                                <span className="char-count">{groupNameChars}</span>
                                {errorMessage && <div className="errorMessage"><InfoHoc viewBox="0 0 8.683 8.683"/><span>Please provide group name</span></div>}
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        </OutsideClickHandler>
    )
};

export default NewGroupProfile;
